import type { FetchConfig } from "../types";

export const base = [] as Array<FetchConfig>
